import { render } from "./AdminManualIdentityValidations.vue?vue&type=template&id=589f11bb&scoped=true"
import script from "./AdminManualIdentityValidations.vue?vue&type=script&lang=js"
export * from "./AdminManualIdentityValidations.vue?vue&type=script&lang=js"

import "./AdminManualIdentityValidations.vue?vue&type=style&index=0&id=589f11bb&scoped=true&lang=css"

import exportComponent from "D:\\PROJET WEB\\carpoolear\\carpoolear_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-589f11bb"]])

export default __exports__